import React from "react";

const ServerSettingIcon = ({ className = "", width = 64, height = 64, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1555 9.25C42.9391 9.25 43.8324 9.25068 44.5352 9.5499C44.9986 9.74626 45.421 10.0358 45.7762 10.4016C46.1312 10.7673 46.413 11.2029 46.6053 11.6819C46.7836 12.1206 46.8514 12.6321 46.8799 13.3794C46.8932 13.9194 47.0389 14.4478 47.3028 14.9136C47.5668 15.3793 47.9412 15.769 48.3898 16.044C48.8481 16.3082 49.3642 16.4487 49.8886 16.4515C50.413 16.4543 50.9302 16.3187 51.3911 16.0594C52.0329 15.709 52.499 15.5168 52.9585 15.4538C53.9641 15.3178 54.9814 15.5969 55.7892 16.2324C56.3932 16.7107 56.8368 17.5046 57.7295 19.093C58.6222 20.6817 59.0682 21.4779 59.1689 22.2535C59.2332 22.7661 59.1985 23.2867 59.0687 23.7857C58.9387 24.2853 58.715 24.7542 58.4102 25.1641C58.1273 25.5419 57.7305 25.8586 57.1155 26.258C56.2113 26.8407 55.6297 27.8375 55.6297 28.936C55.6297 30.0345 56.2113 31.0312 57.1173 31.6159C57.7305 32.0133 58.1273 32.33 58.4084 32.7079C58.7133 33.1174 58.9383 33.585 59.0687 34.0843C59.199 34.5836 59.2329 35.1055 59.1689 35.6185C59.0682 36.3961 58.6222 37.1903 57.7295 38.779C56.8387 40.3674 56.3932 41.1632 55.7892 41.6396C54.9838 42.2754 53.9652 42.556 52.9585 42.4182C52.499 42.3551 52.0329 42.1629 51.3911 41.8126C50.9305 41.5537 50.4145 41.4197 49.8904 41.4224C49.3662 41.4251 48.8499 41.564 48.3916 41.828C47.4669 42.3773 46.9178 43.3943 46.8799 44.4925C46.8514 45.2398 46.7836 45.7514 46.6053 46.1901C46.413 46.669 46.1312 47.1047 45.7762 47.4704C45.421 47.8361 44.9986 48.1257 44.5352 48.3221C43.8324 48.6213 42.9391 48.622 41.1555 48.622C39.3719 48.622 38.4786 48.6213 37.7758 48.3221C36.8378 47.9224 36.093 47.1544 35.7057 46.1901C35.5274 45.7514 35.4596 45.2398 35.4311 44.4925C35.3912 43.3942 34.8441 42.3793 33.9212 41.828C33.4629 41.5637 32.9469 41.4233 32.4224 41.4204C31.8979 41.4177 31.3808 41.5533 30.9199 41.8126C30.278 42.163 29.812 42.3552 29.3525 42.4182C28.3457 42.554 27.3272 42.2755 26.5218 41.6396C25.9178 41.1613 25.4741 40.3674 24.5815 38.779C23.6888 37.1903 23.2428 36.3941 23.1421 35.6185C23.0778 35.1059 23.1125 34.5853 23.2423 34.0863C23.3723 33.5867 23.596 33.1177 23.9008 32.7079C24.1837 32.33 24.5806 32.0133 25.1955 31.614C26.0997 31.0313 26.6813 30.0345 26.6813 28.936C26.6813 27.8375 26.0997 26.8408 25.1937 26.2561C24.5806 25.8587 24.1836 25.5419 23.9026 25.1641C23.2836 24.3356 23.0094 23.2886 23.1421 22.2535C23.2428 21.4759 23.6888 20.6817 24.5815 19.093C25.4722 17.5046 25.9178 16.7087 26.5218 16.2324C27.3296 15.5969 28.3468 15.3178 29.3525 15.4538C29.812 15.5168 30.278 15.709 30.9199 16.0594C31.3805 16.3183 31.8965 16.4523 32.4205 16.4496C32.9448 16.4469 33.4611 16.308 33.9193 16.044C34.3683 15.7692 34.7419 15.3793 35.0063 14.9136C35.2707 14.4478 35.4176 13.9197 35.4311 13.3794C35.4596 12.6341 35.5274 12.1206 35.7057 11.6819C35.8981 11.2026 36.1813 10.7674 36.5367 10.4016C36.8918 10.0359 37.3125 9.74623 37.7758 9.5499C38.4805 9.25068 39.3719 9.25 41.1555 9.25ZM41.1536 23.0302C37.9818 23.0305 35.4126 25.6742 35.4126 28.936C35.4126 32.1978 37.9837 34.8415 41.1536 34.8418C44.3238 34.8418 46.8966 32.198 46.8966 28.936C46.8966 25.674 44.3257 23.0302 41.1536 23.0302Z"
        fill="#B3B4B6"
      />

      <foreignObject x="-6.27188" y="6.00156" width="57.3328" height="33.868">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_0_4060_115366_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <path
        data-figma-bg-blur-radius="10.6"
        d="M39.9639 26.1719C39.9634 26.8604 39.6889 27.5208 39.2021 28.0078C38.7154 28.4947 38.0556 28.7688 37.3672 28.7695H37.3662L7.42578 28.7686C6.73724 28.7681 6.0768 28.4946 5.58984 28.0078C5.10293 27.5209 4.82867 26.8605 4.82812 26.1719V19.6982L4.8418 19.4414C4.90216 18.8477 5.16515 18.2899 5.59082 17.8643C6.07733 17.3777 6.73678 17.1034 7.4248 17.1016H7.42578L37.3662 17.1025H37.3672C38.0549 17.1044 38.7138 17.3781 39.2002 17.8643C39.6866 18.3505 39.9617 19.0096 39.9639 19.6973V26.1719Z"
        fill="#B3B4B6"
        fillOpacity="0.05"
        stroke="url(#paint0_linear_4060_115366)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M32.0491 25.9033C31.8702 25.7164 31.6267 25.6082 31.3706 25.6016C31.11 25.6016 30.8601 25.7063 30.6758 25.8939C30.4916 26.0815 30.3881 26.3359 30.3881 26.6012C30.3881 26.8665 30.4916 27.121 30.6758 27.3086C30.8601 27.4962 31.11 27.6016 31.3706 27.6016C31.6267 27.5949 31.8702 27.4867 32.0491 27.2999C32.228 27.1131 32.3281 26.8625 32.3281 26.6016C32.3281 26.3407 32.228 26.0901 32.0491 25.9033Z"
        fill="url(#paint1_linear_4060_115366)"
      />

      <path
        d="M28.0363 25.956H12.9618C12.7938 25.956 12.6326 26.024 12.5137 26.145C12.3949 26.266 12.3281 26.4301 12.3281 26.6012C12.3281 26.7724 12.3949 26.9365 12.5137 27.0575C12.6326 27.1785 12.7938 27.2465 12.9618 27.2465H28.0363C28.2043 27.2465 28.3655 27.1785 28.4844 27.0575C28.6032 26.9365 28.67 26.7724 28.67 26.6012C28.67 26.4301 28.6032 26.266 28.4844 26.145C28.3655 26.024 28.2043 25.956 28.0363 25.956Z"
        fill="url(#paint2_linear_4060_115366)"
      />

      <foreignObject x="-6.27188" y="19.8687" width="57.3328" height="33.868">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_1_4060_115366_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <path
        data-figma-bg-blur-radius="10.6"
        d="M39.9639 40.0391C39.9634 40.7276 39.6889 41.388 39.2021 41.875C38.7154 42.3619 38.0556 42.636 37.3672 42.6367H37.3662L7.42578 42.6357C6.73724 42.6353 6.0768 42.3618 5.58984 41.875C5.10293 41.3881 4.82867 40.7276 4.82812 40.0391V33.5654L4.8418 33.3086C4.90216 32.7149 5.16515 32.1571 5.59082 31.7314C6.07733 31.2449 6.73678 30.9706 7.4248 30.9688H7.42578L37.3662 30.9697H37.3672C38.0549 30.9716 38.7138 31.2453 39.2002 31.7314C39.6866 32.2177 39.9617 32.8767 39.9639 33.5645V40.0391Z"
        fill="#B3B4B6"
        fillOpacity="0.05"
        stroke="url(#paint3_linear_4060_115366)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M32.0491 36.7079C31.8702 36.5211 31.6267 36.4129 31.3706 36.4062C31.11 36.4062 30.8601 36.511 30.6758 36.6986C30.4916 36.8862 30.3881 37.1406 30.3881 37.4059C30.3881 37.6712 30.4916 37.9257 30.6758 38.1133C30.8601 38.3009 31.11 38.4062 31.3706 38.4062C31.6267 38.3996 31.8702 38.2914 32.0491 38.1046C32.228 37.9177 32.3281 37.6672 32.3281 37.4062C32.3281 37.1453 32.228 36.8948 32.0491 36.7079Z"
        fill="url(#paint4_linear_4060_115366)"
      />

      <path
        d="M28.0363 36.7607H12.9618C12.7938 36.7607 12.6326 36.8287 12.5137 36.9497C12.3949 37.0707 12.3281 37.2348 12.3281 37.4059C12.3281 37.5771 12.3949 37.7412 12.5137 37.8622C12.6326 37.9832 12.7938 38.0512 12.9618 38.0512H28.0363C28.2043 38.0512 28.3655 37.9832 28.4844 37.8622C28.6032 37.7412 28.67 37.5771 28.67 37.4059C28.67 37.2348 28.6032 37.0707 28.4844 36.9497C28.3655 36.8287 28.2043 36.7607 28.0363 36.7607Z"
        fill="url(#paint5_linear_4060_115366)"
      />

      <foreignObject x="-6.27188" y="33.7359" width="57.2625" height="33.8672">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_2_4060_115366_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <path
        data-figma-bg-blur-radius="10.6"
        d="M39.8916 53.9062C39.8911 54.5946 39.6174 55.2543 39.1309 55.7412C38.7049 56.1673 38.1461 56.4307 37.5518 56.4902L37.2949 56.5029H7.42578C6.73724 56.5025 6.0768 56.229 5.58984 55.7422C5.10293 55.2553 4.82867 54.5948 4.82812 53.9062V47.4326L4.8418 47.1758C4.90216 46.5821 5.16515 46.0243 5.59082 45.5986C6.07733 45.1121 6.73678 44.8378 7.4248 44.8359H37.2959L37.5518 44.8496C38.1453 44.9099 38.7033 45.1723 39.1289 45.5977C39.6154 46.084 39.8896 46.7438 39.8916 47.4316V53.9062Z"
        fill="#B3B4B6"
        fillOpacity="0.05"
        stroke="url(#paint6_linear_4060_115366)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M32.0491 49.7382C31.8702 49.4891 31.6267 49.3448 31.3706 49.3359C31.11 49.3359 30.8601 49.4756 30.6758 49.7257C30.4916 49.9759 30.3881 50.3151 30.3881 50.6688C30.3881 51.0226 30.4916 51.3618 30.6758 51.612C30.8601 51.8621 31.11 52.0026 31.3706 52.0026C31.6267 51.9938 31.8702 51.8494 32.0491 51.6003C32.228 51.3513 32.3281 51.0171 32.3281 50.6693C32.3281 50.3214 32.228 49.9873 32.0491 49.7382Z"
        fill="url(#paint7_linear_4060_115366)"
      />

      <path
        d="M28.0363 49.8085H12.9618C12.7938 49.8085 12.6326 49.8992 12.5137 50.0605C12.3949 50.2219 12.3281 50.4407 12.3281 50.6688C12.3281 50.897 12.3949 51.1158 12.5137 51.2772C12.6326 51.4385 12.7938 51.5291 12.9618 51.5291H28.0363C28.2043 51.5291 28.3655 51.4385 28.4844 51.2772C28.6032 51.1158 28.67 50.897 28.67 50.6688C28.67 50.4407 28.6032 50.2219 28.4844 50.0605C28.3655 49.8992 28.2043 49.8085 28.0363 49.8085Z"
        fill="url(#paint8_linear_4060_115366)"
      />

      <defs>
        <clipPath id="bgblur_0_4060_115366_clip_path" transform="translate(6.27188 -6.00156)">
          <path d="M39.9639 26.1719C39.9634 26.8604 39.6889 27.5208 39.2021 28.0078C38.7154 28.4947 38.0556 28.7688 37.3672 28.7695H37.3662L7.42578 28.7686C6.73724 28.7681 6.0768 28.4946 5.58984 28.0078C5.10293 27.5209 4.82867 26.8605 4.82812 26.1719V19.6982L4.8418 19.4414C4.90216 18.8477 5.16515 18.2899 5.59082 17.8643C6.07733 17.3777 6.73678 17.1034 7.4248 17.1016H7.42578L37.3662 17.1025H37.3672C38.0549 17.1044 38.7138 17.3781 39.2002 17.8643C39.6866 18.3505 39.9617 19.0096 39.9639 19.6973V26.1719Z" />
        </clipPath>

        <clipPath id="bgblur_1_4060_115366_clip_path" transform="translate(6.27188 -19.8687)">
          <path d="M39.9639 40.0391C39.9634 40.7276 39.6889 41.388 39.2021 41.875C38.7154 42.3619 38.0556 42.636 37.3672 42.6367H37.3662L7.42578 42.6357C6.73724 42.6353 6.0768 42.3618 5.58984 41.875C5.10293 41.3881 4.82867 40.7276 4.82812 40.0391V33.5654L4.8418 33.3086C4.90216 32.7149 5.16515 32.1571 5.59082 31.7314C6.07733 31.2449 6.73678 30.9706 7.4248 30.9688H7.42578L37.3662 30.9697H37.3672C38.0549 30.9716 38.7138 31.2453 39.2002 31.7314C39.6866 32.2177 39.9617 32.8767 39.9639 33.5645V40.0391Z" />
        </clipPath>

        <clipPath id="bgblur_2_4060_115366_clip_path" transform="translate(6.27188 -33.7359)">
          <path d="M39.8916 53.9062C39.8911 54.5946 39.6174 55.2543 39.1309 55.7412C38.7049 56.1673 38.1461 56.4307 37.5518 56.4902L37.2949 56.5029H7.42578C6.73724 56.5025 6.0768 56.229 5.58984 55.7422C5.10293 55.2553 4.82867 54.5948 4.82812 53.9062V47.4326L4.8418 47.1758C4.90216 46.5821 5.16515 46.0243 5.59082 45.5986C6.07733 45.1121 6.73678 44.8378 7.4248 44.8359H37.2959L37.5518 44.8496C38.1453 44.9099 38.7033 45.1723 39.1289 45.5977C39.6154 46.084 39.8896 46.7438 39.8916 47.4316V53.9062Z" />
        </clipPath>

        <linearGradient
          id="paint0_linear_4060_115366"
          x1="32.5297"
          y1="25.602"
          x2="35.6805"
          y2="36.7649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="#B3B4B6" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_4060_115366"
          x1="30.3281"
          y1="26.9353"
          x2="30.0313"
          y2="22.7977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>

        <linearGradient
          id="paint2_linear_4060_115366"
          x1="30.3281"
          y1="26.9353"
          x2="30.0313"
          y2="22.7977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>

        <linearGradient
          id="paint3_linear_4060_115366"
          x1="32.5297"
          y1="39.4692"
          x2="35.6805"
          y2="50.6321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="#B3B4B6" />
        </linearGradient>

        <linearGradient
          id="paint4_linear_4060_115366"
          x1="30.3281"
          y1="37.74"
          x2="30.0313"
          y2="33.6023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>

        <linearGradient
          id="paint5_linear_4060_115366"
          x1="30.3281"
          y1="37.74"
          x2="30.0313"
          y2="33.6023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>

        <linearGradient
          id="paint6_linear_4060_115366"
          x1="10.3981"
          y1="46.662"
          x2="15.0283"
          y2="61.757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint7_linear_4060_115366"
          x1="30.3281"
          y1="51.1143"
          x2="29.8026"
          y2="45.6193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>

        <linearGradient
          id="paint8_linear_4060_115366"
          x1="30.3281"
          y1="51.1143"
          x2="29.8026"
          y2="45.6193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ServerSettingIcon;
